module.exports = __webpack_public_path__ + "assets/img/TrendingNow_technology.8004df79-ps.jpg";